const FOCUSABLE_SELECTOR = [
  'input:not([disabled]):not([type="hidden"])',
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  '[tabindex]:not([tabindex="-1"]):not([disabled])',
  "a[href]",
].join(", ")

function isRichTextEditor(el: HTMLElement): boolean {
  return !!el.closest(".DraftEditor-root, .rdw-editor-main, .editorClassName")
}

function isSubmitButton(el: HTMLElement): boolean {
  return el.tagName === "BUTTON" && (el as HTMLButtonElement).type === "submit"
}

export function getFormFocusableElements(form: HTMLElement): HTMLElement[] {
  return Array.from(form.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter((el) => {
    if (el.offsetParent === null && el.tagName !== "INPUT") return false
    if (el.classList.contains("modern-date-picker") && el.classList.contains("flatpickr-input") && el.hasAttribute("readonly")) {
      // Skip flatpickr hidden input; use visible alt input instead
      return false
    }
    return true
  })
}

export function focusNextField(current: HTMLElement): boolean {
  const form = current.closest("form")
  if (!form) return false

  const focusable = getFormFocusableElements(form)
  const active = (current.matches(FOCUSABLE_SELECTOR) ? current : current.closest(FOCUSABLE_SELECTOR)) as HTMLElement | null
  const idx = active ? focusable.indexOf(active) : -1

  if (idx >= 0 && idx < focusable.length - 1) {
    focusable[idx + 1].focus()
    if (focusable[idx + 1].tagName === "SELECT") {
      ;(focusable[idx + 1] as HTMLSelectElement).click()
    }
    return true
  }
  return false
}

export function handleFormEnterAsTab(event: React.KeyboardEvent<HTMLElement>): void {
  if (event.key !== "Enter" || event.shiftKey || event.nativeEvent.isComposing) return

  const target = event.target as HTMLElement
  if (target.tagName === "TEXTAREA") return
  if (isRichTextEditor(target)) return
  if (isSubmitButton(target)) return
  if (target.closest(".flatpickr-calendar")) return

  event.preventDefault()
  focusNextField(target)
}

export function bindEnterToNextField(element: HTMLElement | null | undefined): (() => void) | undefined {
  if (!element) return undefined

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== "Enter" || event.shiftKey || event.isComposing) return
    if (isRichTextEditor(event.target as HTMLElement)) return
    event.preventDefault()
    focusNextField(event.target as HTMLElement)
  }

  element.addEventListener("keydown", onKeyDown)
  return () => element.removeEventListener("keydown", onKeyDown)
}
